import React from 'react';
// Images
import GemIcon from '../../assets/images/icons/shining-diamond-icon.svg';
// Constants
import {
  CONTACT_PAGE_URL,
  CompanyName,
  LocationCity,
} from '../../utils/Constants';
// Data
import { mainServicesDataArray } from '../../utils/data/CompanyData';

function MainServicesComponent() {
  return (
    <section className='grid w-full'>
      <div className='grid gap-6 w-full text-center px-6 sm:px-8 md:px-16 lg:container lg:mx-auto'>
        {/* Header */}
        <section>
          <h2 className='text-3xl font-semibold text-colour2 mb-6'>
            {CompanyName} Services
          </h2>
        </section>

        {/* Services Grid */}
        <section className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto'>
          {mainServicesDataArray.map((service, index) => (
            <div
              key={index}
              className='grid p-6 border rounded-lg shadow-lg bg-white'
            >
              <img
                src={service.icon}
                alt={`Service icon for ${service.label}`}
                className='w-10 h-10 mx-auto mb-4'
              />
              <h3 className='text-xl font-semibold uppercase text-colour6'>
                {service.label}
              </h3>
              <p className='mt-2 text-gray-600'>{service.description}</p>
              <div className='pt-4'>
                <a
                  href={service.url}
                  className='text-xl text-colour6 font-semibold'
                  aria-label={`${service.label} page`}
                >
                  Learn More
                </a>
              </div>
            </div>
          ))}
        </section>

        {/* CTA Button */}
        <section className='grid gap-4 pt-2 w-fit text-center mx-auto'>
          <div className='grid'>
            <a
              href={CONTACT_PAGE_URL}
              className='w-full py-2 lg:py-4 lg:px-24 text-colour6 bg-colour1 border-colour6 border-2 border-solid rounded-lg lg:text-xl font-semibold'
            >
              Get a Free Quote Now!
            </a>
          </div>
          <div className='grid items-center justify-center'>
            <div className='grid w-fit'>
              <a href={CONTACT_PAGE_URL} className='font-semibold text-lg'>
                Based in {LocationCity} - Serving Devon & Cornwall
              </a>
            </div>
          </div>

          <div className='grid'>
            <a href={`#main-services`} className='text-colour6'>
              See Full List of Services
            </a>
          </div>
        </section>
      </div>
    </section>
  );
}

export default MainServicesComponent;
